/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleLeftIcon16Solid = forwardRef('ArrowFigureACircleLeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8Zm11.516 0a.75.75 0 0 0-.75-.75H6.15l1.844-1.642a.75.75 0 0 0-.998-1.12L4.52 6.693a1.75 1.75 0 0 0 0 2.614l2.476 2.205a.75.75 0 1 0 .998-1.12L6.15 8.75h5.616a.75.75 0 0 0 .75-.75Z" })));
});
